angular.module('gym.reports').controller('AllScheduledExportsCtrl', ["$scope", "$modalInstance", "$modal", "report", function($scope, $modalInstance, $modal, report) {
  var exportsResource, loadExports;
  $scope.report = report;
  exportsResource = $scope.report.all('export_schedules');
  $scope.currentUser = window.currentUser;
  loadExports = function() {
    return exportsResource.getList({
      list_all: 1
    }).then(function(data) {
      return $scope.exports = data;
    });
  };
  loadExports();
  $scope.edit = function(item) {
    $modalInstance.dismiss('cancel');
    return $modal.open({
      template: require('templates/gyms/reports/schedule_exports_modal.html.slim'),
      controller: 'ScheduleExportsCtrl',
      resolve: {
        report: function() {
          return $scope.report;
        },
        exportId: function() {
          return item.id;
        }
      }
    });
  };
  $scope.remove = function(item) {
    if (window.confirm("Are you sure?")) {
      return item.remove().then(function() {
        return loadExports();
      });
    }
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
